import { EditorActionKey } from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";

export const nonfatalErrorMessage = (
  state: string | null = null,
  action: EditorAction
): string | null => {
  switch (action.type) {
    case EditorActionKey.SET_NONFATAL_ERROR_MESSAGE:
      return action.payload.message;
    default:
      return state;
  }
};
